/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { Links, LinksFromJSON, LinksToJSON } from './Links'
import { Meta, MetaFromJSON, MetaToJSON } from './Meta'
import { Raw, RawFromJSON, RawToJSON } from './Raw'
import { Supplier, SupplierFromJSON, SupplierToJSON } from './Supplier'

/**
 *
 * @export
 * @interface GetSuppliersResponse
 */
export interface GetSuppliersResponse {
  /**
   * HTTP Response Status Code
   * @type {number}
   * @memberof GetSuppliersResponse
   */
  status_code: number
  /**
   * HTTP Response Status
   * @type {string}
   * @memberof GetSuppliersResponse
   */
  status: string
  /**
   * Apideck ID of service provider
   * @type {string}
   * @memberof GetSuppliersResponse
   */
  service: string
  /**
   * Unified API resource name
   * @type {string}
   * @memberof GetSuppliersResponse
   */
  resource: string
  /**
   * Operation performed
   * @type {string}
   * @memberof GetSuppliersResponse
   */
  operation: string
  /**
   *
   * @type {Array<Supplier>}
   * @memberof GetSuppliersResponse
   */
  data: Array<Supplier>
  /**
   *
   * @type {Meta}
   * @memberof GetSuppliersResponse
   */
  meta?: Meta
  /**
   *
   * @type {Links}
   * @memberof GetSuppliersResponse
   */
  links?: Links
  /**
   *
   * @type {Raw}
   * @memberof GetSuppliersResponse
   */
  _raw?: Raw | null
}

export function GetSuppliersResponseFromJSON(json: any): GetSuppliersResponse {
  return GetSuppliersResponseFromJSONTyped(json, false)
}

export function GetSuppliersResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSuppliersResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status_code: json['status_code'],
    status: json['status'],
    service: json['service'],
    resource: json['resource'],
    operation: json['operation'],
    data: (json['data'] as Array<any>).map(SupplierFromJSON),
    meta: !exists(json, 'meta') ? undefined : MetaFromJSON(json['meta']),
    links: !exists(json, 'links') ? undefined : LinksFromJSON(json['links']),
    _raw: !exists(json, '_raw') ? undefined : RawFromJSON(json['_raw'])
  }
}

export function GetSuppliersResponseToJSON(value?: GetSuppliersResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status_code: value.status_code,
    status: value.status,
    service: value.service,
    resource: value.resource,
    operation: value.operation,
    data: (value.data as Array<any>).map(SupplierToJSON),
    meta: MetaToJSON(value.meta),
    links: LinksToJSON(value.links),
    _raw: RawToJSON(value._raw)
  }
}
